import React, { useEffect, useState } from 'react';

function Skills() {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    fetch('https://api.virajpargaonkar.me/api/skills')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch skills');
        return res.json();
      })
      .then((data) => {
        setSkills(data);
      })
      .catch((err) => {
        console.error(err);
        setSkills([]);
      });
  }, []);

  // Group skills by level for display. This groups the array into an object
  // where the keys are levels (Expert, Advanced, Intermediate, etc.).
  const grouped = skills.reduce((acc, skill) => {
    const level = skill.level || 'Other';
    if (!acc[level]) acc[level] = [];
    acc[level].push(skill.name);
    return acc;
  }, {});

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1>Technical Skills</h1>
          <p>An overview of the tools and technologies I work with.</p>
        </div>
      </section>
      <main className="page-content">
        <div className="container">
          <div className="skills-grid">
            {Object.entries(grouped).map(([level, names]) => (
              <div className="skill-category" key={level} data-aos="fade-up">
                <h4>{level}</h4>
                <ul>
                  {names.map((n) => (
                    <li key={n}>{n}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}

export default Skills;